export default "__VITE_PUBLIC_ASSET__fa422093__"